import React, { useEffect } from 'react'
import TopBar from '../components/menu/TopBar'
import ResourceDirectory from '../components/EducationResourceDirectory/ResourceDirectory'
import style from '../components/EducationResourceDirectory/EducationResourceDirectory.module.css'
import { useDispatch } from 'react-redux'
import { fetchEducationResource } from '../stores/slices/educationResourceDirectorySlice'

function EducationResourceDirectory() {
    const dispatch = useDispatch()
    useEffect(() => {
        let params=null
        dispatch(fetchEducationResource(params))
    }, []);
    return (
        <div className={style.content}>
            <TopBar />
            <div className="grid columns-12 gap-6">
                <div className="g-col-12 ">
                    <ResourceDirectory />
                </div>
            </div>
        </div>
    )
}

export default EducationResourceDirectory